import { supabaseClient } from "@/supabase/app";
import { enqueueSnackbar } from "notistack";

export interface EmailAccount {
  id?: number;
  email: string;
  server: string;
  password: string;
  profile_type:string;
  user_id?: string;
  created_at?: string | number | Date;
}

export async function addEmailAccount(
//   id: number,
  emailData: EmailAccount,
//   handleClearData: () => void
) {
  try {
    const { data, error } = await supabaseClient.from("emailAccounts").insert([
      {
        user_id: emailData.id,
        email: emailData.email,
        server: emailData.server,
        password: emailData.password,
        profile_type:emailData.profile_type
      },
    ]);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Email account saved successfully!", {
      variant: "success",
    });
    // handleClearData();
    return data;
  } catch (error) {
    enqueueSnackbar(`Error saving email account: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function getAllEmailAccounts(
//   userId: string
): Promise<EmailAccount[] | null> {
  try {
    const { data, error } = await supabaseClient
      .from("emailAccounts")
      .select("*")
    //   .eq("user_id", userId);

    if (error) {
      throw error;
    }

    return data as EmailAccount[];
  } catch (error) {
    enqueueSnackbar(`Error fetching email accounts: ${error.message}`, {
      variant: "error",
    });
    return null;
  }
}

export async function getEmailAccountById(
    userId: string
  ): Promise<EmailAccount[] | null> {
    try {
      const { data, error } = await supabaseClient
        .from("emailAccounts")
        .select("*")
        .eq("user_id", userId);
  
      if (error) {
        throw error;
      }
  
      return data as EmailAccount[];
    } catch (error) {
      enqueueSnackbar(`Error fetching email accounts: ${error.message}`, {
        variant: "error",
      });
      return null;
    }
  }
export async function updateEmailAccount(
  id: number,
  emailData: EmailAccount
): Promise<void> {
  try {
    const { data, error } = await supabaseClient
      .from("emailAccounts")
      .update({
        email: emailData.email,
        server: emailData.server,
        profile_type:emailData.profile_type,
        password: emailData.password,
      })
      .eq("id", id);

    if (error) {
      throw error;
    }

    enqueueSnackbar("Email account updated successfully!", {
      variant: "success",
    });
  } catch (error) {
    enqueueSnackbar(`Error updating email account: ${error.message}`, {
      variant: "error",
    });
  }
}

export async function deleteEmailAccount(id: number): Promise<void> {
    try {
      const { error } = await supabaseClient
        .from("emailAccounts")
        .delete()
        .eq("id", id);
  
      if (error) {
        throw error;
      }
  
      enqueueSnackbar("Email account deleted successfully!", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(`Error deleting email account: ${error.message}`, {
        variant: "error",
      });
    }
  }
  